
define('ldsh!modules/accounts/status/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="row">\n    <div class="col-md-12">\n        <h4>\n            <span id="statusGroupName">' +
__e(model.get("name")) +
'</span>\n            <small style="white-space: nowrap;">(<span class="i18n" data-i18n="ACCOUNTS.STATUS.LBL_CREATED_AT"></span>: ' +
__e(model.get("createdAt")) +
')</small>\n        </h4>\n    </div>\n</div>\n\n';
 if (model.hasServices()) { ;
__p += '\n\n<ul id="status-tab" class="nav nav-tabs mt24" role="tablist">\n  <li id="mdirectorTab" role="presentation" class="' +
__e(((activeTab === 'mdirector') ? 'active' : '')) +
'">\n    <a href="/accounts/status/mdirector/group/' +
__e(model.id) +
'" class="i18n naranja" data-i18n="ACCOUNTS.STATUS.LBL_MDIRECTOR"></a>\n  </li>\n  <li id="landingsTab" role="presentation" class="' +
__e(((activeTab === 'landings') ? 'active' : '')) +
'">\n    <a href="/accounts/status/landings/group/' +
__e(model.id) +
'" class="i18n naranja" data-i18n="ACCOUNTS.STATUS.LBL_LANDINGS"></a>\n  </li>\n</ul>\n\n<div id="status-tab-content" class="tab-content"></div>\n\n<div class="media mb48">\n    <div class="media-left media-middle">\n        <img width="50" height="50" src="/app/img/icon_operator_phone.png" alt="" />\n    </div>\n    <div class="">\n        <p class="i18n" data-i18n="ACCOUNTS.STATUS.LBL_EXPAND_ACCOUNT"></p>\n        <span>\n            <span class="i18n" data-i18n="ACCOUNTS.STATUS.TXT_SERVICE_PLANNER_CONTACT"></span>\n            <strong><a id="mailto" class="i18n" data-i18n="ACCOUNTS.STATUS.LBL_CONTACT_SUPPORT_EMAIL" href="mailto:soporte@mdirector.com"></a></strong>\n            <span class="i18n" data-i18n="ACCOUNTS.STATUS.TXT_SERVICE_PLANNER_CONTACT2"></span>\n            <strong><span class="i18n" data-i18n="ACCOUNTS.STATUS.LBL_CONTACT_MD_N_PHONE"></span></strong>.\n        </span>\n    </div>\n</div>\n\n';
 } else { ;
__p += '\n<div class="alert alert-danger" role="alert">\n    <span class="i18n" data-i18n="[html]ACCOUNTS.STATUS.NO_SERVICES"></span>\n</div>\n';
 } ;
__p += '\n';

}
return __p
};});

